import Selector from "./Selector.vue";

let vm = new Vue({
    el: '#selector',
    components: {Selector},
})
